import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import {
  GetUserGeolocationResProps,
  ReverseGeocodingReqProps,
  ReverseGeocodingResProps
} from './external.types';

/**
 * External geolocation API used for geo lookup and reverse geocoding requests.
 */
export const externalApi = createApi({
  baseQuery: fetchBaseQuery({}),
  endpoints: (build) => ({
    getUserGeolocation: build.query<GetUserGeolocationResProps, void>({
      query: () => 'https://geolocation-db.com/json/'
    }),
    reverseGeocoding: build.query<ReverseGeocodingResProps, ReverseGeocodingReqProps>({
      query: (params) => ({
        params,
        url: 'https://maps.googleapis.com/maps/api/geocode/json'
      })
    })
  }),
  reducerPath: 'externalApi',
  tagTypes: ['External']
});

export const { useLazyGetUserGeolocationQuery, useLazyReverseGeocodingQuery } = externalApi;
